type BaseAction<T extends string> = { type: T }

// overload 1: NO payload
export function createAction<
  T extends string,
  A extends Record<string, unknown> = Record<string, unknown>
>(
  type: T,
  payload?: undefined,
  additional?: A
): BaseAction<T> & A

// overload 2: WITH payload
export function createAction<
  T extends string,
  P,
  A extends Record<string, unknown> = Record<string, unknown>
>(
  type: T,
  payload: P,
  additional?: A
): BaseAction<T> & { payload: P } & A

// implementation
export function createAction<
  T extends string,
  P,
  A extends Record<string, unknown> = Record<string, unknown>
>(
  type: T,
  payload?: P,
  additional?: A
) {
  if (payload !== undefined) {
    return {
      type,
      payload,
      ...(additional ?? {}),
    }
  }

  return {
    type,
    ...(additional ?? {}),
  }
}

export const createActionCreator =
  <T extends string, P>(type: T, payload: P) =>
    (): { type: T; payload: P } =>
      ({ type, payload })